import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    bankName,
    taxId,
    address,
    city,
    district,
    ward,
    sentDate,
    sendingPeriod,
    sendingTimes,
    bankId,
    signer,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [bankName.name]: Yup.string().required(bankName.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [city.name]: Yup.string().notRequired(city.errorMsg),
  [district.name]: Yup.string().notRequired(district.errorMsg),
  [ward.name]: Yup.number().notRequired(ward.errorMsg),
  [sentDate.name]: Yup.number().required(sentDate.errorMsg),
  [sendingPeriod.name]: Yup.number().required(sendingPeriod.errorMsg),
  [sendingTimes.name]: Yup.number().required(sendingTimes.errorMsg),
  [bankId.name]: Yup.string().required(bankId.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
